import { OptionType } from '@evinced-private/ui-common';

const INITIAL_OPTIONS_COUNT = 3;

const validateOptionsArray = (options: unknown, paramName: string): void => {
	if (!Array.isArray(options)) {
		throw new Error(`${paramName} must be an array, got ${typeof options}`);
	}
};

export const createAsyncLoadOptions = (
	allLabels: OptionType[],
	initialOptions: OptionType[]
): ((searchText: string, callback: (options: OptionType[]) => void) => void) => {
	validateOptionsArray(allLabels, 'allLabels');
	validateOptionsArray(initialOptions, 'initialOptions');

	return (searchText: string, callback: (options: OptionType[]) => void): void => {
		if (!searchText.trim()) {
			callback(initialOptions);
		} else {
			const searchLower = searchText.toLowerCase();
			const filtered = allLabels.filter((opt) => opt.label.toLowerCase().includes(searchLower));
			callback(filtered);
		}
	};
};

export const getInitialOptions = (
	allLabels: OptionType[],
	selectedValues: OptionType[],
	initialOptionsCount: number = INITIAL_OPTIONS_COUNT
): OptionType[] => {
	validateOptionsArray(allLabels, 'allLabels');
	validateOptionsArray(selectedValues, 'selectedValues');

	if (allLabels.length === 0) {
		return [];
	}

	const selectedSet = new Set(selectedValues.map((opt) => opt.value));

	const selected: OptionType[] = [];
	const nonSelected: OptionType[] = [];
	const selectedValueSet = new Set<string | number>();

	for (const opt of selectedValues) {
		if (allLabels.some((label) => label.value === opt.value) && !selectedValueSet.has(opt.value)) {
			selected.push(opt);
			selectedValueSet.add(opt.value);
		}
	}

	for (const opt of allLabels) {
		if (nonSelected.length >= initialOptionsCount) {
			break;
		}
		if (!selectedSet.has(opt.value)) {
			nonSelected.push(opt);
		}
	}

	// Combine: selected + first N non-selected
	return [...selected, ...nonSelected];
};
